import {
  TrackingClient,
  TrackingPageContext,
} from '@aboutyou/legacy-tracking-sdk';
import {useContext} from 'react';
import {useTrackingPageContextCallback} from '../context/PageTrackingContext';
import {
  GTMTrackingClient,
  SearchEventProperties,
} from '../context/TrackingClientContext';

interface TrackingContextAndClient {
  TrackingClient: TrackingClient;
  pageContextCallback: () => TrackingPageContext;
  getSearchEventParams: () => null | SearchEventProperties;
  updateSearchEventParams: (params: Partial<SearchEventProperties>) => void;
  resetSearchEventParams: () => void;
}

export function useTracking(): TrackingContextAndClient {
  const pageContextCallback = useTrackingPageContextCallback();
  const {
    client,
    getSearchEventParams,
    resetSearchEventParams,
    updateSearchEventParams,
  } = useContext(GTMTrackingClient);

  return {
    pageContextCallback,
    TrackingClient: client,
    getSearchEventParams,
    resetSearchEventParams,
    updateSearchEventParams,
  };
}
